import {inject, LOCALE_ID, NgModule} from '@angular/core';

import {
  NgbAccordionModule,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';


import {registerLocaleData} from "@angular/common";
import localeVi from "@angular/common/locales/vi";
import localeViExtra from "@angular/common/locales/extra/vi";
import {CustomAdapter, CustomDateParserFormatter} from "@core/libs/ng-bs/ng-bs-date-adapter";
import {TranslocoService} from '@jsverse/transloco';
import {AppService} from '@core/services/app.service';

registerLocaleData(localeVi, 'vi', localeViExtra);


@NgModule({
  exports: [
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgbNavModule,
    NgbAccordionModule
  ],
  providers: [
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
    {
      provide: LOCALE_ID,
      useFactory: () => {
        return inject(TranslocoService).getActiveLang() ?? 'vi-VN'
      },
      deps: [AppService]
    }
  ],
})
export class NgBootstrapModule {
}

